module.exports = __webpack_public_path__ + "static/media/Host Asset 6.1f35ee91.svg";